<template>
	<div class="d-flex">
		<template v-if="switchMonthYear">
			<div>
				<b-form-select
					v-model="month"
					:options="monthOptions"
					:disabled="disabled"
					class="w-auto"
					@input="monthChanged"
				/>
			</div>
			<div class="ml-2">
				<b-form-select
					v-model="year"
					:options="yearOptions"
					:disabled="disabled"
					class="w-auto"
					@input="yearChanged"
				/>
			</div>
		</template>
		<template v-else>
			<div>
				<b-form-select
					v-model="year"
					:options="yearOptions"
					:disabled="disabled"
					class="w-auto"
					@input="yearChanged"
				/>
			</div>
			<div class="ml-2">
				<b-form-select
					v-model="month"
					:options="monthOptions"
					:disabled="disabled"
					class="w-auto"
					@input="monthChanged"
				/>
			</div>
		</template>
		<div v-if="withDay" class="ml-2">
			<b-form-select
				v-model="day"
				:options="dayOptions"
				:disabled="disabled"
				class="w-auto"
				@input="dayChanged"
			/>
		</div>
	</div>
</template>

<script>
import {DateTime} from "luxon";
import _ from "lodash";
import {getDaysInMonth, getMonthName} from "@/helper/Date";

export default {

	props: {
		value: {
			type: Object,
			required: false,
		},
		startYear: {
			type: Number,
			required: false,
		},
		yearReverse: {
			type: Boolean,
			required: false,
			default: false,
		},
		yearsInPast: {
			type: Number,
			required: false,
			default: 0,
		},
		yearsInFuture: {
			type: Number,
			required: false,
			default: 5,
		},
		withDay: {
			type: Boolean,
			required: false,
			default: true,
		},
		switchMonthYear: {
			type: Boolean,
			required: false,
			default: false,
		},
		disabled: {
			type: Boolean,
			required: false,
			default: false,
		},
	},

	data ()
	{
		const now = DateTime.now();

		let yearOptions = _.map(
			_.range(this.startYear || (now.year - this.yearsInPast), now.year + this.yearsInFuture + 1),
			year =>
			{
				return {value: year, text: year};
			}
		);

		if (this.value?.year && !_.find(yearOptions, option => option.value === this.value.year))
		{
			yearOptions.push({
				value: this.value.year,
				text: this.value.year
			});
		}

		yearOptions = _.sortBy(yearOptions, 'value');

		if (this.yearReverse)
		{
			yearOptions = _.reverse(yearOptions);
		}

		return {
			year: this.value ? this.value.year : null,
			month: this.value ? this.value.month : null,
			day: this.value ? this.value.day : null,
			yearOptions: Object.freeze(yearOptions),
			monthOptions: Object.freeze(
				_.map(
					_.range(1, 13),
					month =>
					{
						return {value: month, text: getMonthName(month)};
					}
				)
			),
		}
	},

	computed: {
		dayOptions ()
		{
			let days = 31;

			if (this.year && this.month)
			{
				days = getDaysInMonth(this.year, this.month);
			}

			return _.map(
				_.range(1, days + 1),
				day =>
				{
					return {value: day, text: day};
				}
			);
		},
	},

	methods: {
		yearChanged ()
		{
			this.checkValues();
			this.emitChangeEvent();
		},
		monthChanged ()
		{
			this.checkValues();
			this.emitChangeEvent();
		},
		dayChanged ()
		{
			this.checkValues();
			this.emitChangeEvent();
		},
		checkValues ()
		{
			if (this.year && !_.find(this.yearOptions, option => option.value === this.year))
			{
				this.year = null;
			}

			if (this.month && !_.find(this.monthOptions, option => option.value === this.month))
			{
				this.month = null;
			}

			if (this.day && !_.find(this.dayOptions, option => option.value === this.day))
			{
				this.day = null;
			}
		},
		emitChangeEvent ()
		{
			if (this.year && this.month && (this.day || !this.withDay))
			{
				this.$emit('input', {
					day: this.day,
					month: this.month,
					year: this.year,
				});

				return;
			}

			this.$emit('input', undefined);
		},
	},
}
</script>
